import { createContext, useContext, useState, useEffect } from 'react'
import { applyThemeColor } from '../utils/registerPwa'

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme') || 'dark'
    // Appliquer immédiatement au chargement
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', savedTheme)
      applyThemeColor(savedTheme)
    }
    return savedTheme
  })

  useEffect(() => {
    console.log('ThemeContext: Mise à jour du thème vers:', theme)
    localStorage.setItem('theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
    applyThemeColor(theme)
    console.log('data-theme appliqué:', document.documentElement.getAttribute('data-theme'))
  }, [theme])

  const toggleTheme = () => {
    // Pour compatibilité avec l'ancien système
    setTheme(prev => prev === 'dark' ? 'light' : 'dark')
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}


